import { useState } from "react";

function NewsRating({ initialRate = 0, onRate }) {
  const [rating, setRating] = useState(initialRate);

  return (
    <div className="news-rating">
      {[1,2,3,4,5].map((star) => (
        <span
          key={star}
          className={`star ${star <= rating ? "active" : ""}`}
          onClick={() => { setRating(star); onRate(star); }}
          style={{ cursor: "pointer", fontSize: "24px", color: star <= rating ? "#facc15" : "#d1d5db" }}
        >
          ★
        </span>
      ))}
    </div>
  );
}

export default NewsRating;